import { TextField, TextFieldProps } from '@mui/material'
import { FC, InputHTMLAttributes, useMemo } from 'react' // Import MUI TextField component
import { useField } from 'formik' // Import formik hook
import InputMask from 'react-input-mask' // Import input mask

interface PhonefieldWrapperProps extends InputHTMLAttributes<HTMLInputElement> {
  mask: string
  name: string
}

const PhonefieldWrapper: FC<PhonefieldWrapperProps & TextFieldProps> = ({
  mask,
  name,
  ...otherProps
}) => {
  const [field, meta] = useField(name)

  const configTextfield: TextFieldProps = {
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
  }

  const configInputMask = useMemo(() => {
    const config = {
      alwaysShowMask: true,
      mask,
      ...field,
      value: field.value || '',
    }

    if (meta && meta.touched && meta.error) {
      return {
        ...config,
        error: true,
        helperText: meta.error,
      }
    }

    return config
  }, [meta, mask, field])

  return (
    <InputMask {...configInputMask}>
      <TextField name={name} {...configTextfield} />
    </InputMask>
  )
}

export default PhonefieldWrapper
